import { createSlice } from "@reduxjs/toolkit";
import { Pagination } from "../../../utils/api";
import { User } from "../../users/store/slice";

export type Company = {
  id: number;
  ax_code: string;
  name: string;
  vat_code: string;
  manager_code: string;
  credit_limit: string;
  payment_term: string;
  active: boolean;
  restricted: boolean;
  invoice_import_enabled: boolean;
  created_at: string;
  updated_at: string;
  users?: User[];
};

type InitialState = {
  data: Company[];
  meta: Pagination | null;
  isLoading: boolean;
  isCreating: boolean;
  isUpdating: boolean;
  isRemoving: boolean;
  editableIndex: number | undefined;
  search: string;
};

const initialState: InitialState = {
  data: [],
  meta: null,
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  isRemoving: false,
  editableIndex: undefined,
  search: "",
};

const companyPageSlice = createSlice({
  name: "companyPageSlice",
  initialState,
  reducers: {
    fetchData: (state) => {
      state.data = [];
      state.meta = null;
      state.isLoading = true;
    },
    loadMore: (state) => {
      state.isLoading = true;

      if (state.meta) {
        state.meta.current_page++;
      }
    },
    create: (state, action) => {
      state.isCreating = true;
    },
    update: (state, action) => {
      state.isUpdating = true;
    },
    remove: (state, action) => {
      state.isRemoving = true;
    },
    setData: (state, action) => {
      const { data, meta } = action.payload;

      state.data = data;
      state.meta = meta;
    },
    addData: (state, action) => {
      const { data, meta } = action.payload;

      state.data = [...state.data, ...data];
      state.meta = meta;
    },
    addCompany: (state, action) => {
      state.data = [action.payload, ...state.data];
    },
    removeCompany: (state) => {
      state.data.shift();
    },
    updateCompany: (state, action) => {
      const updatedCompany: Company = action.payload;

      const index = state.data.findIndex(
        (company) => company.id === updatedCompany.id
      );

      if (index !== -1) {
        state.data[index] = updatedCompany;
      }
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsCreating: (state, action) => {
      state.isCreating = action.payload;
    },
    setIsUpdating: (state, action) => {
      state.isUpdating = action.payload;
    },
    setIsRemoving: (state, action) => {
      state.isRemoving = action.payload;
    },
    setEditableIndex: (state, action) => {
      state.editableIndex = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.data = [];
      state.isLoading = true;
      state.meta = null;
    },
    reset: () => initialState,
  },
});

export default companyPageSlice;
